import React, { useState, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';
import AlertToast from 'components/AlertToast';
import ServiceDealForm from './service-deal-form';

import ViewWrapper from 'views/ViewWrapper';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
});

function CreateEditServiceDeal({ ...props }) {
  const { classes, title } = props;

  const history = useHistory();

  function goBack() {
    history.push('/service-deals');
  }

  const [toastMessage, setToast] = useState({});

  const clearToast = useCallback(() => {
    setToast({});
  }, []);

  return (
    <ViewWrapper>
      <AlertToast message={toastMessage.message} onClear={clearToast} alertType={toastMessage.alertType} />
      <MuiPaper className={classes.paper}>
        <MuiGrid container spacing={1}>
          <MuiGrid item xs={12}>
            <MuiTypography variant="h6">{title}</MuiTypography>
          </MuiGrid>
          <ServiceDealForm goBack={goBack} setToast={setToast} id={props?.match?.params?.id} />
        </MuiGrid>
      </MuiPaper>
    </ViewWrapper>
  );
}

export default withStyles(styles)(CreateEditServiceDeal);
